import apiClient from './apiClient';

export const getCurrentUser = () => apiClient.get('/users/me');
export const getUserProfile = async () => {
  try {
    return await getCurrentUser();
  } catch (error) {
    return await apiClient.get('/auth/me');
  }
};
export const updateUserProfile = (payload) => apiClient.patch('/users/profile', payload);
export const getProfile = () => apiClient.get('/users/profile');
